import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
    Widget,
    WidgetContent,
    WidgetHeader,
    WidgetTitle,
} from "frontend-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";
import IssuesStatusStats from "./IssuesStatusStats";
import { IssuesStatusList } from "./IssuesStatusList";

export function IssuesStatusWidget() {
    const { t } = useTranslation();

    return (
        <Widget>
            <WidgetHeader>
                <WidgetTitle>{t("common.issuesByStatus")}</WidgetTitle>
                <TooltipProvider>
                    <Tooltip>
                        <TooltipTrigger
                            type="button"
                            aria-label={t("common.lastTwelveMonthsDisclaimer")}
                            className="text-compendia-muted hover:text-compendia-foreground focus-visible:ring-border-focus inline-flex size-4 items-center justify-center rounded-full focus-visible:ring-2 focus-visible:outline-none"
                        >
                            <FontAwesomeIcon icon={faCircleInfo} className="size-4" />
                        </TooltipTrigger>
                        <TooltipContent>{t("common.lastTwelveMonthsDisclaimer")}</TooltipContent>
                    </Tooltip>
                </TooltipProvider>
            </WidgetHeader>
            <WidgetContent>
                <IssuesStatusList />
                <div className="border-compendia-border overflow-hidden rounded-[3px] border">
                    <IssuesStatusStats />
                </div>
            </WidgetContent>
        </Widget>
    );
}
